<template>
  <div class="player-panel-queue queue">
    <div class="queue-head">
      <div class="random">
        <label for="randomSwitch" class="text">
          {{ $t('PLAYER.RANDOM') }}
        </label>
        <div class="mk-switch">
          <input id="randomSwitch" v-model="random" type="checkbox" class="switch">
          <label for="randomSwitch" />
          <span class="switch-container" />
        </div>
      </div>
      <div :class="{'disabled': random}" class="reset" @click="reset">
        <i class="material-icons">
          delete
        </i>
        <span class="text">
          {{ $t('PLAYER.RESET') }}
        </span>
      </div>
    </div>
    <div v-if="random" class="random-box">
      <div v-if="randomUpdating" class="random-loading">
        <Loader />
      </div>
      <div v-if="!randomUpdating">
        <div class="random-track">
          <PlayerPanelTrackInfo :track="currentTrack" />
        </div>
        <div class="random-img-radio">
          <img src="@/assets/images/img-radio/img-radio.png" alt="Radio" height="150">
        </div>
        <a class="random-next-icon" @click="randomNext">
          <i class="material-icons">
            skip_next
          </i>
        </a>
        <a class="random-next-text" @click="randomNext">
          {{ $t('PLAYER.NEXT_TEXT') }}
        </a>
        <!-- <Paganiniplus /> -->
      </div>
    </div>
    <div v-else class="queue-list">
      <div v-for="(track, index) in queue" :key="index" class="queue-item">
        <div class="info">
          <PlayerPanelTrackInfo :track="track" />
        </div>
        <div class="control">
          <a class="player-btn">
            <PlayerPlayBtn :in-list="true" :in-list-index="index" :in-list-track-id="track.id"
                           :width="40" :height="40" :type="'static'" @click="play(index, track)"
            />
          </a>
          <a class="track-more">
            <PlayerDropdown :index="index" :open-index="openIndex" @updateOpenIndex="updateIndex">
              <template slot="toggle">
                <i class="material-icons">
                  more_horiz
                </i>
              </template>
              <template slot="menu">
                <div class="track-dropdown">
                  <ul class="track-dropdown-list">
                    <li class="item pointer" @click="addToMyPlaylist(track)">
                      <i class="icon material-icons">
                        add_circle_outline
                      </i>
                      <span class="text">
                        {{ $t('TRACK.ADD_TO_PLAYLIST') }}
                      </span>
                    </li>
                    <li class="item pointer" @click="shareTrack(track)">
                      <i class="icon material-icons">
                        share
                      </i>
                      <span class="text">
                        {{ $t('TRACK.SHARE') }}
                      </span>
                    </li>
                    <li class="item pointer" @click="removeFromQueue(index)">
                      <i class="icon material-icons">
                        delete
                      </i>
                      <span class="text">
                        {{ $t('TRACK.REMOVE_TRACK') }}
                      </span>
                    </li>
                  </ul>
                </div>
              </template>
            </PlayerDropdown>
          </a>
        </div>
      </div>
      <div v-if="queue.length === 0" class="queue-list-empty">
        <img class="img" src="@/assets/images/player/img-queue-empty.svg">
        <div class="text">
          <div class="line">
            {{ $t('PLAYER.EMPTY_QUEUE_TEXT') }}
          </div>
          <div class="line">
            {{ $t('PLAYER.GET_SOME_FROM_PLAYLIST') }}
          </div>
          <RouterLink
            :to="{ name:'playlistById', params: { locale: $i18n.localePath(), id: '8bab9510-83cc-455c-b931-80610e18f8b5' }}"
            class="try-it-link"
          >
            {{ $t('PLAYER.TRY_IT') }}  <i class="material-icons">
              chevron_right
            </i>
          </RouterLink>
        </div>
      </div>
    </div>

    <PlaylistGoLoginModal
      :open="openGoToLoginModal"
      @close="openGoToLoginModal = false"
    />

    <PlaylistTrackAddingModal
      :open="openAddingModal"
      :selected-track="selectedTrack"
      @close="openAddingModal = false"
    />

    <TrackShareModal
      v-if="selectedTrack && selectedTrack.id"
      :title="`${composerName} - ${workName} - ${trackName}`"
      :open="openShareTrack"
      :track="selectedTrack"
      @close="openShareTrack = false"
    />
  </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex'
import Loader from '@/components/common/Loader'
import PlayerPlayBtn from '@/components/player/PlayerPlayBtn'
import PlayerDropdown from '@/components/player/PlayerDropdown'
import PlayerPanelTrackInfo from '@/components/player/PlayerPanelTrackInfo'
import PlaylistGoLoginModal from '@/components/playlist/PlaylistGoLoginModal'
import PlaylistTrackAddingModal from '@/components/playlist/PlaylistTrackAddingModal'
import TrackShareModal from '@/components/track/TrackShareModal'
import { displayTrackName, displayComposerName, displayPerformerName } from '@/assets/helpers/TrackHelper.js'
import { displayWorkName } from '@/assets/helpers/WorkHelper'
import { displayMovementName } from '@/assets/helpers/MovementHelper'
import { getCookie } from '@/assets/helpers/UtilHelper'
// import Paganiniplus from '@/components/tsp/Paganiniplus'

export default {
  name: 'PlayerPanel',
  components: {
    // Paganiniplus,
    Loader,
    PlayerPlayBtn,
    PlayerDropdown,
    PlayerPanelTrackInfo,
    PlaylistGoLoginModal,
    PlaylistTrackAddingModal,
    TrackShareModal
  },
  props: {},
  data() {
    return {
      randomUpdating: false,
      openIndex: -1,
      openGoToLoginModal: false,
      openAddingModal: false,
      openShareTrack: false,
      selectedTrack: {}
    }
  },
  computed: {
    random: {
      get() {
        return this.$store.state.player.random
      },
      set(value) {
        if (value) {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
        } else {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
        }
        //
        this.$store.commit('TOGGLE_PLAYER_RANDOM', value)
      }
    },
    composerName() {
      return this.selectedTrack && this.selectedTrack.movement
        ? this.displayComposerName(this.selectedTrack.movement.work.people)
        : ''
    },
    movementName() {
      return this.selectedTrack && this.selectedTrack.movement
        ? this.displayMovementName(this.selectedTrack.movement)
        : ''
    },
    trackName() {
      return this.workName && this.movementName
        ? this.workName === this.movementName
          ? this.movementName
          : this.workName + ' ' + this.movementName
        : ''
    },
    workName() {
      return this.selectedTrack && this.selectedTrack.movement
        ? this.displayWorkName(this.selectedTrack.movement.work)
        : ''
    },
    ...mapState({
      initialClick: state => state.player.initialClick,
      queue: state => state.player.queue,
      pool: state => state.player.pool,
      currentIndex: state => state.player.index,
      currentTrack: state => state.player.track,
      currentTrackId: state => state.player.trackId,
      paused: state => state.player.paused,
      currentTime: state => state.player.currentTime
    }),
    ...mapGetters([
      'isAuthenticated'
    ])
  },
  watch: {
    async random(newValue, oldValue) {
      if (newValue) {
        if (!this.initialClick) {
          // Trigger click-to-play policy
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
        this.randomUpdating = true
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
        await this.$store.dispatch('RANDOM_POOL')
        this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        this.randomUpdating = false
      } else {
        this.$store.commit('RANDOM_POOL_RESET')
        this.$store.commit('SET_PLAYER_INDEX', this.currentIndex)
      }
    }
  },
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
    displayTrackName,
    displayComposerName,
    displayPerformerName,
    displayMovementName,
    displayWorkName,
    getCookie,
    reset() {
      if (!this.random) {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
        this.$store.commit('RESET_QUEUE')
      }
    },
    play(index, track) {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if ((!this.paused || this.currentTime > 0) && this.currentIndex !== index) {
        this.$store.dispatch('INCREASE_PLAYING_COUNT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
      }

      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }

      if (this.currentIndex === index) {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', !this.paused)
      } else {
        this.$store.commit('SET_PLAYER_INDEX', index)
        if (this.paused) {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
        }
      }
      // this.$nextTick(() => {
      //   this.$store.commit('TOGGLE_PLAYER_PAUSED', !this.paused)
      // })
    },
    pause() {
      this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
    },
    randomNext() {
      if (!this.paused || this.currentTime > 0) {
        this.$store.dispatch('INCREASE_PLAYING_COUNT')
      }
      this.$store.dispatch('RANDOM_NEXT')
    },
    updateIndex(newIndex) {
      this.openIndex = newIndex
    },
    addToMyPlaylist(track) {
      if (this.isAuthenticated) {
        this.selectedTrack = track
        this.openAddingModal = true
      } else {
        this.openGoToLoginModal = true
      }
    },
    shareTrack(track) {
      this.selectedTrack = track
      this.openShareTrack = true
    },
    removeFromQueue(index) {
      if (index === this.currentIndex) {
        this.$store.commit('REMOVE_TRACK_FROM_QUEUE', index)
        if (this.currentIndex === this.queue.length) {
          this.$store.commit('SET_PLAYER_INDEX', this.currentIndex - 1)
        } else {
          this.$store.commit('SET_PLAYER_INDEX', this.currentIndex)
        }
      } else if (index < this.currentIndex) {
        this.$store.commit('REMOVE_TRACK_FROM_QUEUE', index)
        this.$store.commit('SET_PLAYER_INDEX', this.currentIndex - 1)
      } else if (index > this.currentIndex) {
        this.$store.commit('REMOVE_TRACK_FROM_QUEUE', index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/switch.scss';
@import '@/assets/scss/component/player.scss';

@mixin vertical-align-middle() {
  &:before{
    content:'';
    width:0;
    height:100%;
    display:inline-block;
    position:relative;
    vertical-align:middle;
  }
  > * {
    display: inline-block;
    vertical-align: middle;
  }
}

.queue {
  &-head {
    height: $player-panel-title-height;
    padding: 0 24px;
    .random {
      float: left;
      height: 100%;
      user-select: none;
      @include vertical-align-middle();
      .text {
        margin-right: 8px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63;
        color: $grey-50;
      }
      .toggle {
        cursor: pointer;
      }
      .toggle.active {
        color: $theme-yellow;
      }
    }
    .reset {
      float: right;
      height: 100%;
      color: $grey-9b;
      cursor: pointer;
      user-select: none;
      @include vertical-align-middle();
      &.disabled {
        cursor: not-allowed;
        color: $grey-ec;
      }
      .text {
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
  &-list {
    overflow-x: hidden;
    overflow-y: scroll;
    height: calc(#{$player-panel-height} - #{$player-tab-height} - #{$player-panel-title-height});
    border-top: solid 1px $grey-ec;
    &-empty {
      margin-top: 16px;
      text-align: center;
      img {
        width: auto;
      }
      .text {
        margin: 16px 0;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.6;
        .line {
          padding: 0 24px;
        }
        .try-it-link {
          display: block;
          font-size: 14px;
          font-weight: 500;
          line-height: 32px;
          color: $link-hover;
          text-decoration: none;
          i {
            font-size: 14px;
            vertical-align: middle;
          }
        }
      }
    }
    .info {
      float: left;
      width: calc(100% - 102px); // for text overflow
      .subject,
      .perform {
        width: 100%;
        color: $grey-7d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .subject {
        height: 33px; // 26+7
        padding-top: 7px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63; // 26px
      }
      .perform {
        height: 18px;
        font-size: 12px;
        line-height: 1.5; // 18px
      }
    }
    .control {
      float: right;
      width: 102px;
      height: 100%;
      text-align: right;
      @include vertical-align-middle();
      .player-btn,
      .track-more {
        margin-left: 16px;
        text-decoration: none;
        color: $grey-7d;
        cursor: pointer;
      }
    }
  }
  &-item {
    height: $player-panel-item-height;
    padding: 0 24px;
    border-bottom: solid 1px $grey-ec;
  }
}

.random {
  &-box {
    text-align: center;
  }
  &-track {
    height: 48px;
    width: calc(100% - 48px);
    margin: 0 auto;
    &-name {
      font-size: 16px;
      font-weight: 700;
      line-height: 26px;
      @include default-link-hover($grey-7d);
    }
    &-perform {
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      color: $grey-7d;
    }
  }
  &-img-radio {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  &-next-icon {
    display: block;
    i {
      font-size: 36px;
      @include default-link-hover($grey-7d, $grey-7d);
    }
  }
  &-next-text {
    display: block;
    height: 18px;
    margin: 4px 0;
    font-size: 12px;
    font-weight: 500;
    @include default-link-hover($grey-9b);
  }
}
.track-more {
  .track-dropdown {
    position: relative;
    &-list {
      z-index: 99;
      position: absolute;
      top: 8px;
      right: -8px;
      min-width: 250px;
      margin: 0; // reset ul
      padding: 0; // reset ul
      // max-height: 110px;
      border: solid 1px #f7f7f7;
      border-radius: 4px;
      background-color: white;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      .item {
        display: block;
        width: 100%;
        height: 55px;
        line-height: 55px;
        padding-left: 16px;
        padding-right: 16px;
        letter-spacing: normal;
        color: $grey-7d;
        text-align: left;
        text-decoration: none;
        border-bottom: 1px solid #f7f7f7;
        &:last-child {
          border-bottom: 0
        }
        .icon {
          font-size: 20px;
        }
        .text {
          font-size: 16px;
          font-weight: 700;
          margin-left: 16px;
        }
        .icon,
        .text {
          line-height: 55px;
          vertical-align: middle;
        }
      }
      .item:hover {
        color: $link-hover;
      }
      &::before{
        z-index: 98;
        content: " ";
        position: absolute;
        top: -12px;
        right: 8px;
        display: block;
        border-style: solid;
        border-color: transparent;
        border-width: 10px;
        border-top-width: 0;
        border-bottom-color: darken(#f3f3f3, 5%);
      }
      &::after{
        z-index: 100;
        content: " ";
        position: absolute;
        top: -8px;
        right: 10px;
        display: block;
        border-style: solid;
        border-color: transparent;
        border-width: 8px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  $player-panel-height: 445px;
  $player-panel-margin: 0;
  $player-panel-width: 100%;
  $player-tab-height: 48px;
  $player-panel-title-height: 36px;
  .queue {
    &-head {
      height: $player-panel-title-height;
      padding: 0 24px;
    }
    &-list {
      height: calc(#{$player-panel-height} - #{$player-tab-height} - #{$player-panel-title-height});
      &-empty {
        img {
          width: 230px;
        }
      }
    }
  }
}
</style>
